// extracted by mini-css-extract-plugin
export default {"root":"HCmdTc89xmRO8xkLZA01","header":"gKS0SbCqhtQ_hJ8DmXTc","body":"fhCx_kBi4j4irJ6wn4qg"};